
import axios from 'axios';
import cookies from 'vue-cookies';
import router from '@/router/index';

import Helper from '@/lib/langTemplates/HelperClauses';

const baseUrl = 'https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/auth';

const Auth = {

  state: {

    email: '',
    pw: '',
    changeTempEmail: '',
    newPassword: '',
    newTempPw: '',
    forgotEmail: '',
    confPw: '',
    matchConfPw: '',
    confCode: '',

    temporary: false

  },

  mutations: {

    togTemporary(state, temp) {
      state.temporary = temp
    }

  },

  actions: {

    async login(context, creds){
      cookies.remove('breeziProTkn');
      try {
        const tkn = (await axios.post(baseUrl, JSON.stringify(creds))).data;
        $cookies.set('breeziProTkn', tkn);
        context.commit('startSession');
      } catch(err) {
        throw (err);
        if (err.response.data === 'replace temporary password') {
          context.dispatch('setTemporary', true);
        } else {
          context.dispatch('initNotif', {
            type: 'err',
            title: Helper.clauses.logFail[`${context.rootState.lang}Title`],
            body: Helper.clauses.logFail[context.rootState.lang]
          });
        }
      }
    },

    // async updateTemporaryPw(context, creds){
    //   try {
    //     const tkn = ()
    //   }
    // }

    forceUpdate(context, params){
      let url = `${baseUrl}/${params.code ? 'forcePw' : 'forgotPw'}`;
      let axiosParams = {
        method: 'POST',
        url: url,
        headers: {'Content-Type': 'application/json'},
        data: JSON.stringify(params)
      }
      return new Promise((resolve, reject) => {
        axios(axiosParams)
          .then(res => {
            resolve();
          }).catch(err => {
            console.log(err);
            reject();
          })
      });
    },

    setTemporary(context, temp){
      context.commit('togTemporary', temp)
    }

  }

}

export default Auth;



// WEBPACK FOOTER //
// ./src/store/auth.js